var map = {
	"./ActivateIcon.svg": "01f6",
	"./CheckIcon.svg": "c37c",
	"./CheckMessage.svg": "85b0",
	"./DeleteIcon.svg": "236f",
	"./EditIcon.svg": "085a",
	"./FwMenuIcon.svg": "fa1f",
	"./FwRecordIcon.svg": "ed11",
	"./FwWifiIcon.svg": "2320",
	"./HelpArrow.svg": "5121",
	"./HelpIcon.svg": "9153",
	"./LabelIcon.svg": "194e",
	"./Language.svg": "7ba1",
	"./LanguageIcon.svg": "90e0",
	"./MainAllClose.svg": "69db",
	"./MenuHistory.svg": "6d3b",
	"./MenuHome.svg": "41f2",
	"./MenuMessage.svg": "a4c8",
	"./MessageIcon.svg": "5d43",
	"./MobileFilterBtn.svg": "b7be",
	"./NeglectIcon.svg": "7222",
	"./PauseIcon.svg": "c00f",
	"./PersonIcon.svg": "d8ed",
	"./RefillIcon.svg": "30aa",
	"./RelieveIcon.svg": "89ca",
	"./ResetIcon.svg": "e6c7",
	"./RestartIcon.svg": "7283",
	"./RetractIcon.svg": "3f61",
	"./SearchIcon.svg": "82ae",
	"./SettingIcon.svg": "39ce",
	"./StopIcon.svg": "839b",
	"./TimeIcon.svg": "5392"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";